import "./number-auto-increment";
import "./slider";
import "./accordeon";
import "./animation";
import "./leaflet-ic";
import "./tabs";
import "./parallax";
import "./youtube";
